import { VideoQuality } from '../../webrtc/media';

/**
 * Gets the device's default video quality
 */
export const getDefaultVideoQuality = (): VideoQuality => 'sd';
